import store from '../store/store'
import { logErrorModal } from '../repositories/HomeRepository'

const REASONS = {
    REACT_ERROR_BOUNDARY: 'react_error_boundary',
    WINDOW_ERROR: 'window_error',
    UNHANDLED_REJECTION: 'unhandled_rejection',
}

const COOLDOWN_MS = 10000

let lastSentAt = 0

/**
 * Notify the backend that the global error modal was shown.
 * Fire-and-forget: never throws; failures are ignored so the modal still works offline or if the API fails.
 * Only one request is sent per incident: subsequent calls within COOLDOWN_MS are ignored to avoid
 * duplicate logs when both the Error Boundary and window error/unhandledrejection fire for the same error.
 *
 * @param {string} reason - One of: react_error_boundary, window_error, unhandled_rejection
 * @param {Object} [details] - Optional: { message?: string, stack?: string, url?: string }
 */
export const notifyErrorModalShown = (reason, details = {}) => {
    try {
        const now = Date.now()
        if (now - lastSentAt < COOLDOWN_MS) {
            return
        }
        lastSentAt = now

        const state = store.getState()
        const userId = state?.AuthSlice?.user?.id ?? null

        const payload = {
            reason,
            user_id: userId,
            message: details.message ?? '',
            stack: details.stack ?? '',
            url:
                details.url ??
                (typeof window !== 'undefined' ? window.location.href : ''),
        }

        logErrorModal(payload).catch(() => {
            // Ignore network/API errors; modal already shown
        })
    } catch {
        // Never let this break the app
    }
}

export { REASONS }
